import { TypographyProps, theme } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-button
import { ButtonProps } from '@aloft/toolkit-sui/chakra';

export const fieldTypographyProps: TypographyProps = {
  variant: 'body1',
  color: 'textPrimary',
  __dangerDoNotUseSx: {
    width: '100%',
    height: '32px',
    backgroundColor: theme.colors.textOffset,
    padding: '4px 8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    whiteSpace: 'nowrap',
  },
};

export const readOnlyFieldTypographyProps: TypographyProps = {
  ...fieldTypographyProps,
  __dangerDoNotUseSx: {
    ...fieldTypographyProps.__dangerDoNotUseSx,
    backgroundColor: theme.colors.surface2,
  },
};

export const popoverInputFocusSx = {
  outline: '1.5px solid',
  outlineOffset: '-1.5px',
  outlineColor: theme.colors.selected2,
} as const;

export const sharedButtonStyle: Partial<ButtonProps> = {
  width: '100%',
  height: '32px',
  borderRadius: '0',
  color: theme.colors.textPrimary,
  padding: '4px 8px',
  fontWeight: 'normal',
  outline: '0',
  _active: {},
  _focus: {},
  _focusVisible: {
    outline: '1.5px solid',
    outlineOffset: '-1.5px',
    outlineColor: '#3355db',
  },
  _focusWithin: {},
  _hover: { backgroundColor: theme.colors.surface2 },
};

export const popoverInputSx = {
  height: '100%',
  padding: '0',
  border: 'none',
  outline: 'none',
  borderRadius: '0',
  fontSize: '14px',
  _focusVisible: {},
} as const;

export const readOnlyFieldProps = (colSpan: number): TypographyProps => ({
  ...readOnlyFieldTypographyProps,
  __dangerDoNotUseSx: {
    ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
    gridColumn: `span ${colSpan}`,
  },
});

/**
 * Returns title + backgroundColor for a field that may be empty.
 * When `isEmpty` is true the cell is highlighted to prompt the user to fill it in.
 */
export const emptyFieldStyle = (
  isEmpty: boolean,
  emptyTitle = 'This field is empty. Please input a value.',
): { title?: string; backgroundColor: string } => ({
  title: isEmpty ? emptyTitle : undefined,
  backgroundColor: isEmpty ? theme.colors.selected4 : theme.colors.surface1,
});
